import { api } from "./api";

export const adminsList = async (params: { search?: string }): Promise<any> => {
  const { data } = await api.get("store/users", { params });
  return data;
};

export const adminsCreate = async (body: {
  name: string;
  phone: string;
}): Promise<any> => {
  const { data } = await api.post("store/users", body);
  return data;
};

export const adminsUpdate = async (body: {
  id: string | number;
  name?: string;
  phone?: string;
}): Promise<any> => {
  const { data } = await api.put("store/users/update", body);
  return data;
};

export const adminsDelete = async (body: {
  id: string | number;
}): Promise<any> => {
  const { data } = await api.put("store/users/delete", body);
  return data;
};
